import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { css } from "@emotion/react";
import { transferToNative, WebAppBridge } from "@src/lib/WebAppBridge";
import AdInputSearchingItems from "./AdInputSearchingItems";
import AdOutFilter from "./AdOutFilter";
import { useFilterStore } from "@src/store/filterStore";
import { useNavigate } from "react-router-dom";

export type openOutFilterName =
    | "loc"
    | "use"
    | "counter_force_list"
    | "auction_master_item"
    | "skp_type"
    | "due_date"
    | "est_price"
    | "min_price";

interface Props {
    isShowFilter: boolean;
    setIsShowFilter: Dispatch<SetStateAction<boolean>>;
    // true일 경우 경공매(type)/진행상태(status) 탭을 추가로 노출 (커뮤니티 필터에서 사용)
    withAuctionTypeAndStatus?: boolean;
    // 필터를 닫았을 때 복귀할 라우트 (기본값: 광고 필터)
    filterRoute?: string;
}

const AdSearchInputAndFilter: React.FC<Props> = ({
    isShowFilter,
    setIsShowFilter,
    withAuctionTypeAndStatus = false,
    filterRoute = "/advertisement/filter",
}) => {
    const navigate = useNavigate();
    const [isOpenRecentKeywordList, setIsOpenRecentKeywordList] = useState(false);

    const [openOutFilter, setOpenOutFilter] = useState<string>("");
    const filterStoreState = useFilterStore((state) => state.filterState);

    WebAppBridge.openFilter = (filterName) => {
        setOpenOutFilter(filterName);
    };

    const handleFilterSelectDone = () => {
        setOpenOutFilter("");
    };

    useEffect(() => {
        if (isOpenRecentKeywordList === true) {
            transferToNative("full", "resizeWebview");
        } else {
            transferToNative(openOutFilter ? "full" : "default", "resizeWebview");
        }
        if (openOutFilter === "") {
            transferToNative(JSON.stringify(filterStoreState), "changeSearchItemsFilter");
            navigate(filterRoute);
        }
    }, [openOutFilter, filterStoreState]);

    // 뒤로가기시에 홈으로
    WebAppBridge.onBackButtonPressed = () => {
        if (openOutFilter !== "") {
            transferToNative(true, "respondBackButtonPressed");
            setOpenOutFilter("");
        } else {
            transferToNative(false, "respondBackButtonPressed");
        }
    };

    return (
        <div css={rootStyle}>
            <div css={rootBoxStyle(!!openOutFilter)}>
                <AdInputSearchingItems
                    isShowFilter={isShowFilter}
                    setIsShowFilter={setIsShowFilter}
                    openOutFilter={openOutFilter}
                    onFilterOff={handleFilterSelectDone}
                    isOpenRecentKeywordList={isOpenRecentKeywordList}
                    setIsOpenRecentKeywordList={setIsOpenRecentKeywordList}
                />
            </div>
            <AdOutFilter
                openOutFilter={openOutFilter}
                setOpenOutFilter={setOpenOutFilter}
                withAuctionTypeAndStatus={withAuctionTypeAndStatus}
            />
        </div>
    );
};

export default AdSearchInputAndFilter;

const rootStyle = css`
    width: 100vw;
    height: 100dvh;
    display: flex;
    flex-direction: column;
`;

const rootBoxStyle = (isShowFilterList: boolean) => css`
    padding: 14px 14px 0;
    height: 62px;
    background-color: ${isShowFilterList ? "#ffffff" : "rgba(255, 255, 255, 1)"};
`;
